import type { ButtonHTMLAttributes, Ref } from "react";
import { styled } from "@pigment-css/react";
import { DotsHorizontal } from "@acto/web-common/components";
import { HeaderIconButton } from "./HeaderIconButton";

// DotsHorizontal has a 13:3 viewBox; width-only sizing keeps it from being squashed square.
const Root = styled(HeaderIconButton)({
  "& svg": { width: "18px", height: "auto" },
});

interface HeaderMoreButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  "aria-label": string;
  ref?: Ref<HTMLButtonElement>;
}

export function HeaderMoreButton({ type = "button", ...rest }: HeaderMoreButtonProps) {
  return (
    <Root type={type} {...rest}>
      <DotsHorizontal aria-hidden="true" />
    </Root>
  );
}
